/**
 * Аватар пользователя: загруженное фото или DiceBear Initial Face (placeholder).
 * Placeholder — inline SVG, чтобы работала анимация стиля.
 */

import { Avatar, AvatarFallback, AvatarImage } from "@studyhub/ui/components/avatar";
import { DicebearFace } from "@/components/shared/dicebear-face";
import { resolveDicebearUserSeed } from "@/lib/dicebear-seed";

export interface UserAvatarProps {
	name?: string | null;
	avatarUrl?: string | null;
	/** Opaque SHA-256 seed с сервера (паритет с IEC Hero). */
	avatarSeed?: string | null;
	userId?: string | null;
	className?: string;
	fallbackClassName?: string;
	alt?: string;
}

function initialsOf(name: string | null | undefined): string {
	if (!name?.trim()) return "?";
	const parts = name.trim().split(/\s+/);
	const first = parts[0]?.[0] ?? "";
	const second = parts[1]?.[0] ?? "";
	return (first + second).toUpperCase() || "?";
}

export function UserAvatar({
	name,
	avatarUrl,
	avatarSeed,
	userId,
	className,
	fallbackClassName,
	alt,
}: UserAvatarProps) {
	const initials = initialsOf(name);
	const label = alt ?? name ?? "";

	if (avatarUrl) {
		return (
			<Avatar className={className}>
				<AvatarImage src={avatarUrl} alt={label} />
				<AvatarFallback className={fallbackClassName}>{initials}</AvatarFallback>
			</Avatar>
		);
	}

	const seed = resolveDicebearUserSeed({ avatarSeed, id: userId, name });

	return (
		<Avatar className={className}>
			<DicebearFace seed={seed} className="size-full" label={label || undefined} />
		</Avatar>
	);
}
